<template>
  <!-- :class="comment.can_be_blurred && comment.user[0].id !== authUser.user.id ? 'blur' : ''" -->
  <div
    class="position-relative comment rounded"
    :style="
      comment.user[0].role === 'doctor' || comment.user[0].role === 'ohcp'
        ? 'background: #F8FEFF'
        : comment.user[0].role === 'admin'
        ? 'background: #EBFCF5'
        : comment.user[0].role === 'nfp_administrator'
        ? 'background: #FFFCF5'
        : comment.user[0].role === 'advocate'
        ? 'background: #FFFFFF'
        : comment.user[0].role === 'hospital_administrator'
        ? 'background: #FFFCF5'
        : comment.user[0].role === 'clinic_administrator'
        ? 'background: #FFFCF5'
        : 'background: #FFFFFF'
    "
  >
    <!-- <div :class="comment.can_be_blurred ? 'overlay blur' : ''"></div> -->
    <div class="comment-section pb-2">
      <div class="comment-head">
        <!-- <img
            @click="viewProfile(comment.user[0])"
            :src="comment.user[0].url ? comment.user[0].url : default_img"
            alt=""
            class="post-comment-image cp"
          /> -->
        <a-avatar
          :style="{ color: ' #ffffff !important', 'background-color': comment.user[0].url ? comment.user[0].url : getAvatarColor(comment.user.id) }"
          @click="viewProfile(comment.user[0])"
          :src="!comment.user[0].deactivated ? comment.user[0].url : null"
          :size="40"
          :class="`text-capitalize mr-2 comment-avatar ${comment.user[0].deactivated ? 'no-click' : 'cp'}`"
        >
          <!-- {{
              comment.user[0].first_name
                ? comment.user[0].first_name[0] +
                  (comment.user[0].last_name
                    ? comment.user[0].last_name[0].toUpperCase()
                    : "")
                : comment.user[0].display_name
                ? comment.user[0].display_name[0]
                : "D"
            }} -->
          <!-- {{ getUserInitials }} -->
          <!-- {{       comment.user[0].display_name
                  ? comment.user[0].display_name[0].toUpperCase() : comment.user[0].first_name[0] + comment.user[0].last_name[0]
         }} -->
          {{ comment.user[0].deactivated ? "AU" : getQuestionInitials }}
        </a-avatar>
        <div class="comment-user">
          <div class="d-flex align-items-center mobile-style">
            <span class="commentor-name">
              {{
                comment.user[0].deactivated
                  ? "Anonymous User"
                  : comment.user[0].role === "doctor" || comment.user[0].role === "physician"
                  ? "Dr. " +
                    // comment.user[0].first_name +
                    // " " +
                    // comment.user[0].last_name
                    comment.user[0].display_name
                  : comment.user[0].display_name
              }}
            </span>
            <template v-if="comment.reply_to_reply">
              <!-- <template v-if="comment.commented_on_type === 2"> -->
              <span class="p-1">
                <i class="fa fa-chevron-right px-2" aria-hidden="true" style="font-size: 12px"></i>
              </span>
              <span class="commentor-name">
                {{
                  comment.user[0].deactivated
                    ? "Anonymous User"
                    : parentUser.role === "doctor" || parentUser.role === "physician"
                    ? "Dr. " +
                      // parentUser.first_name +
                      // " " +
                      // parentUser.last_name
                      parentUser.display_name
                    : parentUser.role === "patient" || parentUser.role === "caregiver"
                    ? parentUser.display_name
                    : // parentUser.first_name + " " + parentUser.last_name
                      parentUser.display_name
                }}
              </span>
            </template>
          </div>

          <div class="py-1 d-flex flex-wrap gap8" v-if="!comment.user[0].deactivated && comment.user[0].role === 'hospital_administrator'">
            <span class="post-physician py-1 px-2 orange-text orange-bg font12">
              <font-awesome-icon size="1x" :icon="['far', 'hospital-alt']" class="mr-1" />
              Hospital
            </span>
            <span class="font12 fw700 py-1 px-2 rounded" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="comment.user[0].speciality">
              {{ comment.user[0].speciality }}
            </span>
          </div>
          <div class="d-flex flex-wrap gap8" v-if="!comment.user[0].deactivated && comment.user[0].role === 'clinic_administrator'">
            <span class="post-physician py-1 px-2 orange-text orange-bg font12">
              <font-awesome-icon size="1x" :icon="['far', 'hospital']" class="mr-1" />
              Clinic
            </span>
            <span class="font12 fw700 py-1 px-2 rounded" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="comment.user[0].speciality">
              {{ comment.user[0].speciality }}
            </span>
          </div>
          <div class="d-flex flex-wrap gap8 p-0" v-if="!comment.user[0].deactivated && (comment.user[0].role === 'doctor' || comment.user[0].role === 'physician')">
            <span class="post-physician py-1 px-2 orange-bg orange-text font12">
              <font-awesome-icon size="1x" :icon="['far', 'user-md']" class="mr-1" />
              Physician
            </span>
            <span class="font12 fw700 py-1 px-2 rounded" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="comment.user[0].speciality">
              {{ comment.user[0].speciality }}
            </span>
          </div>
          <div class="p-0 d-flex flex-wrap gap8" v-if="!comment.user[0].deactivated && (comment.user[0].role === 'hcp' || comment.user[0].role === 'ohcp')">
            <span class="post-physician py-1 px-2 orange-bg orange-text font12">
              <font-awesome-icon size="1x" :icon="['far', 'user-nurse']" class="mr-1" />
              Advanced Practice Provider
            </span>
            <span class="font12 fw700 py-1 px-2 rounded" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="comment.user[0].speciality">
              {{ comment.user[0].speciality }}
            </span>
          </div>
          <div class="d-flex flex-wrap gap8" v-if="!comment.user[0].deactivated && (comment.user[0].role === 'nfp_administrator' || comment.user[0].role === 'nfp')">
            <span class="post-physician py-1 px-2 orange-text orange-bg font12">
              <font-awesome-icon size="1x" :icon="['far', 'hand-holding-heart']" class="mr-1" />
              Non For Profit
            </span>
            <span class="font12 fw700 py-1 px-2 rounded" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }" v-if="comment.user[0].speciality">
              {{ comment.user[0].speciality }}
            </span>
          </div>
          <div class="d-flex flex-wrap gap8 my-1" v-if="!comment.user[0].deactivated && comment.user[0].role === 'advocate'">
            <div class="post-physician py-1 px-2 font12" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }">
              <font-awesome-icon :icon="['fas', 'bullhorn']" class="mr-1" />
              Advocate
            </div>
            <div v-if="comment.user[0].organization" class="bg-purple50 purple300 rounded fw700 font12 py-1 px-2 ml-2">Supporting {{ comment.user[0].organization }}</div>
          </div>
          <div class="post-physician py-1 px-2 turquoise-text turquoise-bg font12" v-if="comment.user[0].role === 'admin'">DoveMed Admin</div>
          <!-- <div class="py-1" v-if="!comment.user[0].deactivated && comment.user[0].role === 'hospital_administrator'">
            <span class="post-physician py-1 px-2 orange-text orange-bg font12">
              <font-awesome-icon size="1x" :icon="['far', 'hospital-alt']" class="mr-1" />
              Hospital
            </span>
            <span class="font12 pl-1"> {{ comment.user[0].speciality }} </span>
          </div>
          <div class="" v-if="!comment.user[0].deactivated && comment.user[0].role === 'clinic_administrator'">
            <span class="post-physician py-1 px-2 orange-text orange-bg font12">
              <font-awesome-icon size="1x" :icon="['far', 'hospital']" class="mr-1" />
              Clinic
            </span>
          </div>
          <div class="p-0" v-if="!comment.user[0].deactivated && (comment.user[0].role === 'doctor' || comment.user[0].role === 'physician')">
            <span class="post-physician py-1 px-2 orange-bg orange-text font12">
              <font-awesome-icon size="1x" :icon="['far', 'user-md']" class="mr-1" />
              Physician
            </span>
            <span class="font12 pl-1"> {{ comment.user[0].speciality }} </span>
          </div>
          <div class="post-physician p-1 pl-2 pr-2 mt-2 mb-2" v-if="!comment.user[0].deactivated && (comment.user[0].role === 'nfp' || comment.user[0].role === 'nfp_administrator')">
            Non For Profit
          </div>
          <div class="d-flex my-1" v-if="!comment.user[0].deactivated && comment.user[0].role === 'advocate'">
            <div class="post-physician py-1 px-2 font12" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }">
              <font-awesome-icon :icon="['fas', 'bullhorn']" class="mr-1" />
              Advocate
            </div>
            <div v-if="comment.user[0].organization">Supporting {{ comment.user[0].organization }}</div>
            <div v-else class="orange-text font12">
              <font-awesome-icon size="1x" :icon="['far', 'user-md']" class="mr-1" />
              Advocate for
              {{ currentCircle.condition_type.slice(0, 20) }}
              {{ currentCircle.condition_type.length > 20 ? "..." : "" }}
            </div>
          </div> -->
        </div>

        <template v-if="!comment.can_be_blurred">
          <!-- MENU FOR OTHERS POSTS -->
          <button v-if="comment.user[0].id !== authUser.user.id || comment.user[0].role !== authUser.user.role" class="threedot-menu" @click="() => (displayDots = !displayDots)">
            <div class="dot-menu-cont">
              <font-awesome-icon class="gray400 h16" :icon="['far', 'ellipsis-v']" />
            </div>
            <div :class="`${displayDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`">
              <p class="card-item d-flex align-items-center" @click="() => $refs.reportContentModal.show(comment, 2)" v-if="!comment.admin_unflagged">
                <font-awesome-icon size="1x" :icon="['fal', 'flag']" class="mr-2 w30" />
                Report Content or Spam
              </p>
            </div>
          </button>

          <!-- MENU FOR SELF POSTS -->
          <button
            class="threedot-menu"
            v-if="comment.user[0].id === authUser.user.id && comment.user_role !== 'admin' && comment.user[0].role === authUser.user.role"
            @click="() => (displayDots = !displayDots)"
          >
            <div class="dot-menu-cont">
              <font-awesome-icon class="gray400 h16" :icon="['far', 'ellipsis-v']" />
            </div>
            <div :class="`${displayDots ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`">
              <p class="card-item" @click="deleteComment">
                <font-awesome-icon size="1x" :icon="['fal', 'trash']" class="mr-2" />
                {{ comment.commented_on_type === 1 ? "Delete Comment" : "Delete Reply" }}
              </p>
            </div>
          </button>
        </template>
      </div>

      <template v-if="!comment.can_be_blurred">
        <p class="overflow-hidden gray600 font16">{{ comment.comment_text }}</p>
        <div v-for="image in comment.comment_attach_url" :key="image.name">
          <img :src="image.url" :alt="image.name" width="50%" class="poll-comment-image" />
        </div>
      </template>
    </div>

    <!-- <p class="posted">Posted {{ formatPostTime(comment.created_at) }}</p> -->

    <!-- REACTIONS -->
    <!-- <div style="display: flex; justify-content: space-between">
        <div id="hugs" class="u-options" @click="react(comment, $event, true)">
          <font-awesome-icon
            size="1x"
            :icon="
              reactions.hugs ? ['fas', 'hands-heart'] : ['fal', 'hands-heart']
            "
            :style="{ color: reactions.hugs ? getPrimaryColor() : '' }"
          />
          <div class="posted-reactions-text">
            Embrace ({{ comment.reaction.hugs }})
          </div>
        </div>
        <div id="likes" class="u-options" @click="react(comment, $event, true)">
          <font-awesome-icon
            size="1x"
            :icon="reactions.likes ? ['fas', 'heart'] : ['fal', 'heart']"
            :style="{ color: reactions.likes ? getPrimaryColor() : '' }"
          />
          <div class="posted-reactions-text">
            Like ({{ comment.reaction.likes }})
          </div>
        </div>
        <div class="u-options" @click="replies.length === 0 && fetchReplies()">
          <font-awesome-icon size="1x" :icon="['fal', 'reply']" />
          <div class="posted-reactions-text">
            Reply ({{ comment.comments_count }})
          </div>
        </div>
        <div id="flag" class="u-options" @click="react(comment, $event, true)">
          <font-awesome-icon
            size="1x"
            :icon="reactions.flag ? ['fas', 'flag'] : ['fal', 'flag-alt']"
            :style="{ color: reactions.flag ? getPrimaryColor() : '' }"
          />
          <div class="posted-reactions-text">Flag</div>
        </div> -->
    <!-- </div> -->
    <div v-if="comment.can_be_blurred" class="font14 bg-error50-30 gray900 p-3 rounded">Comment removed due to community guidelines breach</div>

    <div v-else class="d-flex">
      <p class="posted my-auto">
        {{ formatPostTimeShort(comment.created_at) }}
      </p>
      <div id="likes" class="u-options" @click="react(comment, $event, true)">
        <!-- <font-awesome-icon
            size="1x"
            :icon="reactions.likes ? ['fas', 'heart'] : ['fal', 'heart']"
            :style="{ color: reactions.likes ? getPrimaryColor() : '' }"
          /> -->
        <div class="posted-reactions-text my-auto mx-3 reply-btns" :style="{ color: getPrimaryColor(), 'font-weight': reactions.likes ? '900' : '400' }">
          {{ reactions.likes ? "Liked" : "Like" }}
        </div>
      </div>
      <div class="u-options" v-if="!comment.reply_to_reply" @click="() => (showWritable = !showWritable)">
        <!-- @click="replies.length === 0 && fetchReplies()" -->
        <div class="posted-reactions-text reply-btns" :style="{ color: getPrimaryColor() }">Reply</div>
      </div>
      <p class="ml-auto d-flex align-items-center">
        <!-- <img src="../../assets/emojis/like-40.png" class="hw20 mr-1" alt="likes" /> -->
        <font-awesome-icon :icon="['fas', 'heart-circle']" class="hw20 mr-1 error500" />
        {{ comment.reaction.likes || "0" }}
      </p>
    </div>

    <!-- <hr v-if="showWritable" /> -->
    <div v-if="isImageUploading" class="d-flex justify-content-center mt-2">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-33px', 'margin-top': '40px' }">Loading image...</div>
    </div>
    <div v-if="fileList.length" class="image-uploading">
      <a-upload v-if="fileList.length" listType="picture-card" class="position-relative avatar-uploader" :fileList="fileList" @preview="handlePreview" @change="handleChange"></a-upload>
      <a-modal wrap-class-name="preview-modal" :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <img style="width: 100%" :src="previewImage" />
      </a-modal>
    </div>

    <!-- <div
      v-if="showWritable"
      class="mt-3 ml-5 d-flex justify-content-between position-relative mobile-write"
    >

      <div class="title cp" :style="{ 'font-size': '16px' }">
      
        <a-avatar
          :style="{
            color: ' #ffffff !important',
            'background-color': authUser.user.url
              ? authUser.user.url
              : getAvatarColor(authUser.user.id)
          }"
          @click="viewProfile(authUser)"
          :size="40"
          :src="authUser.user.url"
          alt=""
          class="post-comment-image cp text-capitalize"
        >
         
          {{ getAuthUserInitials() }}
        </a-avatar>
      </div>
      <a-input
        class="replyInput"
        placeholder="Add a reply..."
        v-model="reply"
        @keyup.enter="postReply()"
        style="padding-right: 50px"
      />
      <div class="d-flex align-items-center position-relative cp">
        <font-awesome-icon
          size="1x"
          class="position-absolute reply-cam-right"
          :style="{ top: '2px', transform: 'scale(0.6)' }"
          :icon="['fal', 'camera']"
        />
        <input
          class="camera-icon-inp position-absolute reply-cam-right"
          type="file"
          ref="fileInput"
          @change="handlePicUpload()"
        />
      </div>
      <span
        class="position-absolute"
        :style="{
          display: 'flex',
          'align-self': 'center',
          'z-index': '10',
          right: '24px',
          top: '5px'
        }"
      >
        <span
          class="cp"
          :style="{ transform: 'scale(0.75) translateY(-3px)' }"
          ref="BlackEmojiPicker"
        >
          <BlackEmojiPicker
            :visible="emojiVisible"
            :handleVisible="handleEmojiVisible"
            :insert="insert"
          />
        </span>
        <span
          class="cp font14 fw700 ml-1 mt-1 hide-in-mobile"
          :style="{ color: getPrimaryColor() }"
          @click="postReply()"
        >
          Reply
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
          class="my-auto cp font14 show-in-mobile fw700 h18 reply-arrow"
          :style="{ fill: getPrimaryColor() }"
          @click="postReply()"
        >
          <path
            d="M81.9 27.8C47.1 12.7 12.8 50.1 30.8 83.5l69.3 128.8c4.4 8.3 12.6 13.8 21.9 15c0 0 0 0 0 0l176 22c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22s0 0 0 0c-9.3 1.2-17.5 6.8-21.9 15L30.8 428.5c-18 33.4 16.3 70.8 51.1 55.7L523.8 292.7c32.1-13.9 32.1-59.5 0-73.4L81.9 27.8z"
          />
        </svg>
      </span>
    
     
    </div> -->

    <div v-if="showWritable" class="mt-3 ml-5 d-flex align-items-center">
      <a-avatar
        :style="{
          'background-color': authUser.user.url ? '' : getAvatarColor(authUser.user.id),
        }"
        :size="40"
        :src="authUser.user.url"
        alt=""
        class="post-comment-image text-capitalize comment-avatar font-white"
        @click="viewProfile(authUser)"
      >
        {{ getAuthUserInitials() }}
      </a-avatar>
      <div class="d-flex align-items-center flex-grow-1 comment-container">
        <a-textarea class="replyInput reply-textarea" placeholder="Add a reply..." v-model="reply" @keyup.enter="postReply()" auto-size size="large" />
        <div class="position-relative cp camera">
          <font-awesome-icon class="hw20" :icon="['fal', 'camera']" />
          <input class="camera-icon-inp position-absolute hw20" type="file" accept="image/png, image/jpeg, image/gif, image/svg+xml" ref="fileInput" @change="handlePicUpload()" />
        </div>
        <BlackEmojiPicker :visible="emojiVisible" :handleVisible="handleEmojiVisible" :insert="insert" class="emoji" />
        <span class="cp font14 fw700 hide-in-mobile text" :style="{ color: getPrimaryColor() }" @click="postReply()">Reply</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="cp font14 show-in-mobile fw700 h40 reply-arrow icon" :style="{ fill: getPrimaryColor() }" @click="postReply()">
          <path
            d="M81.9 27.8C47.1 12.7 12.8 50.1 30.8 83.5l69.3 128.8c4.4 8.3 12.6 13.8 21.9 15c0 0 0 0 0 0l176 22c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22s0 0 0 0c-9.3 1.2-17.5 6.8-21.9 15L30.8 428.5c-18 33.4 16.3 70.8 51.1 55.7L523.8 292.7c32.1-13.9 32.1-59.5 0-73.4L81.9 27.8z"
          />
        </svg>
      </div>
    </div>

    <div v-if="replies && !comment.can_be_blurred" :style="{ 'margin-left': comment.commented_on_type === 1 ? '43px' : '0' }">
      <div v-for="reply in replies" :key="reply.id">
        <CommentReplyQANew
          :commentData="reply"
          :parentUserData="comment.user[0]"
          :postComment="postComment"
          :removeCommentFromDisplay="removeCommentFromDisplay"
          :setLoadingScreen="setLoadingScreen"
        />
        <!-- <hr v-if="index < replies.length - 1" /> -->
      </div>
      <!-- <span
          :style="{
            color: getPrimaryColor(),
            textAlign: 'center',
            display: 'block',
            cursor: 'pointer',
          }"
          class="mt-2"
          v-if="replies.length < pagination.total_count"
          @click="fetchReplies(true, true)"
        >
          View More replies ...
        </span> -->
      <div
        v-if="replies.length < pagination.total_count"
        :style="{
          color: getPrimaryColor(),
          'margin-left': comment.commented_on_type === 1 ? '0' : '20px',
        }"
        class="font14 cp d-flex mt-3"
        @click="fetchReplies(true, true)"
      >
        <svg :style="{ fill: getPrimaryColor() }" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w20 mr-1">
          <path
            d="M366.4 414C357.7 410.2 352 401.5 352 392L352 303.1H80C35.87 303.1 0 268.1 0 223.1V48C0 39.16 7.156 32 16 32C24.84 32 32 39.16 32 48V223.1C32 250.5 53.53 271.1 80 271.1H352L352 184C352 174.5 357.7 165.8 366.4 162C375.2 158.2 385.3 159.9 392.3 166.4L504.3 270.4C509.4 275.2 512 281.6 512 287.1C512 294.4 509.4 300.8 504.3 305.6L392.3 409.6C385.3 416.1 375.2 417.8 366.4 414V414zM384 373.7L476.2 288L384 202.3V373.7z"
          />
        </svg>
        See {{ pagination.total_count - replies.length }} More
        {{ pagination.total_count - replies.length === 1 ? "Reply" : "Replies" }}
      </div>
    </div>
    <ReportContentModal ref="reportContentModal" />
  </div>
</template>

<script>
const default_img = require("../../../../assets/images/icon_profile.svg")
import { library } from "@fortawesome/fontawesome-svg-core"
import { faHandsHeart } from "@fortawesome/pro-solid-svg-icons"
import { faHeart, faFlag, faHandHoldingHeart } from "@fortawesome/free-solid-svg-icons"
import ReportContentModal from "../../../Modals/ReportContent.vue"
import { faEllipsisV } from "@fortawesome/pro-regular-svg-icons"
import { faTrash } from "@fortawesome/pro-light-svg-icons"
library.add(faHeart, faFlag, faHandHoldingHeart, faHandsHeart, faEllipsisV, faTrash)
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import BlackEmojiPicker from "../../../home/BlackEmojiPicker.vue"
import s3Upload from "../../../../utilities/imageUploader"

const PostRepository = RepositoryFactory.get("posts")
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "CommentReplyQANew",
  props: {
    commentData: Object,
    parentUserData: Object,
    postComment: Function,
    removeCommentFromDisplay: Function,
    setLoadingScreen: Function,
  },

  computed: {
    getUserInitials() {
      let f = "",
        l = ""
      if (this.comment.user[0].role === "patient" || this.comment.user[0].role === "caregiver") {
        f = this.comment.user[0].display_name ? this.comment.user[0].display_name[0] : "D"
      } else {
        f = this.comment.user[0].first_name ? this.comment.user[0].first_name[0] : "D"
        l = this.comment.user[0].last_name ? this.comment.user[0].last_name[0] : ""
      }
      return f.toUpperCase() + l.toUpperCase()
    },

    getQuestionInitials() {
      let f = "",
        l = ""
      if (this.comment.user[0].display_name) {
        f = this.comment.user[0].display_name.split(" ")[0][0] || "A"
        l =
          this.comment.user[0].display_name
            .split(" ")
            .slice(1)
            .join(" ")[0] || ""
      } else {
        f = this.comment[0].user.first_name ? this.comment[0].user.first_name[0] : "D"
        l = this.comment[0].user.last_name ? this.comment[0].user.last_name[0] : ""
      }
      return f.toUpperCase() + l.toUpperCase()
    },
  },
  components: {
    // Comment,
    ReportContentModal,
    // RemoveUserModal,
    // VEmojiPicker,
    // EmojiPicker,
    // SharePostModal,
    // DeletePostModal,
    // Reactions,
    // EmojiReactions,
    BlackEmojiPicker,
  },
  data() {
    return {
      replies: [],
      pagination: {
        page_num: this.currentPage,
        page_size: this.limit,
        total_count: 0,
      },
      reply: "",
      comment: null,
      parentUser: null,
      showWritable: false,
      currentPage: 1,
      limit: 1,
      reactions: {
        hugs: false,
        likes: false,
        fav: false,
        flag: false,
      },
      posting: false,
      displayDots: false,
      emojiVisible: false,
      loading: false,
      comment_attach: [],
      isImageUploading: false,
      previewVisible: false,
      previewImage: "",
      fileList: [],
    }
  },

  created() {
    console.log("CommentReplyQANew.vue is created:", this.commentData)
    window.addEventListener("mouseup", e => {
      if (this.displayDots) {
        setTimeout(() => {
          this.displayDots = false
        }, 100)
      }
      if (e.target.className === "emoji-picker") {
        return
      }
      if (this.emojiVisible) {
        setTimeout(() => {
          this.emojiVisible = false
        }, 100)
      }
    })
    this.comment = this.commentData
    // console.log(
    //   this.comment.comment_text,
    //   "-> commentData ->",
    //   this.commentData
    // );
    this.parentUser = this.parentUserData
    this.reactions.hugs = !!this.getReaction(1).length
    this.reactions.likes = !!this.getReaction(2).length
    this.reactions.fav = !!this.getReaction(4).length
    this.reactions.flag = !!this.getReaction(5).length
    this.fetchReplies()
  },

  filters: {
    humanize: function(value, capitalize = true) {
      if (!value) return ""
      return capitalize
        ? value
            .toLowerCase()
            .split("_")
            .map(e => e.toUpperCase())
            .join(" ")
        : value
            .toLowerCase()
            .split("_")
            .map(e => e.charAt(0).toUpperCase() + e.substring(1))
            .join(" ")
    },
  },

  methods: {
    async handlePicUpload() {
      // console.log("handlePicUpload is called");
      const file = this.$refs.fileInput.files[0]
      this.isImageUploading = true
      try {
        if (file.size / (1024 * 1024) > 1) {
          this.$notification.error({
            message: "Error",
            description: "File size exceeds 1MB limit",
          })
          const input = this.$refs.file
          input.type = "text"
          input.type = "file"
          this.isImageUploading = false
        }
        if (!file.type.includes("image")) {
          this.$notification.error({
            message: "Error",
            description: "Please select only image",
          })
          this.isImageUploading = false
          return
        }
        const urlPayload = { file_name: [file.name] }
        const urlData = await UserRepository.getPresignedUrl(urlPayload)
        const fileName = urlData.data.data.filename[0]
        await s3Upload(urlData.data.data.url[0], file)
        // this.comment_attach = [fileName]
        // this.comment_attach.push(fileName)
        this.comment_attach.push({ name: fileName, sensitive: false })
        const fileListData = {
          uid: this.comment_attach.length,
          name: file.name,
          status: "done",
          url: urlData.data.data.preview_url,
        }
        this.loading = false
        this.fileList.push(fileListData)
        this.isImageUploading = false
      } catch (err) {
        console.log(err)
      }
      this.isImageUploading = false
      // console.log(this.comment_attach);
    },
    handleCancel() {
      this.previewVisible = false
    },
    handlePreview(file) {
      // console.log("handle Preview ->", file);
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    async handleChange(data) {
      // console.log(data, "<- filelist data");
      this.fileList.length === 1 ? (this.fileList = []) : this.fileList.splice(data.file.uid - 1, 1)
      this.comment_attach.splice(data.file.uid - 1, 1)
    },
    handleEmojiVisible() {
      this.emojiVisible = !this.emojiVisible
    },
    insert(emoji) {
      this.reply += emoji
    },

    deleteComment() {
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      }
      this.$http
        .delete(`${process.env.BASE_API_URL}/comments/?id=${this.comment.id}`, {
          headers,
        })
        .then(res => {
          this.removeCommentFromDisplay(this.comment.id, this.comment.commented_on_type === 3 ? false : true)
        })
        .catch(err => {})
    },
    /**
     * Fetch replies
     *
     */
    fetchReplies(append = false) {
      // this.showWritable = true;
      //  this.setLoadingScreen(true);
      const user = JSON.parse(localStorage.getItem("user"))
      const headers = {
        Authorization: `Bearer ${user.user.token}`,
      }
      this.$http
        .get(`${process.env.BASE_API_URL}/commentsquestionlist/?page_num=${this.currentPage}&items=${this.limit}&comment_id=${this.comment.id}`, {
          headers,
        })
        .then(res => {
          if (append) {
            this.replies.push(...res.data.data.data)
          } else {
            if (res.data) {
              this.replies = res.data.data.data
              this.pagination = res.data.data.paginator
            }
          }
          this.currentPage += 1
          // this.showWritable = true;
          this.setLoadingScreen(false)
        })
        .catch(err => {
          this.setLoadingScreen(false)
        })
    },

    /**
     * Post a reply to a comment
     *
     */
    postReply() {
      if (this.reply.trim().length || this.comment_attach.length) {
        //  this.setLoadingScreen(true);
        const payload = {
          post_parent_id: this.comment.post_parent_id,
          comment_text: this.reply,
          user: this.authUser.user.id,
          commented_on_type: 2,
          commented_on_id: this.comment.id,
          comment_attach: this.comment_attach,
          reply_to_reply: this.comment.commented_on_type === 2 ? true : false,
        }
        const headers = {
          Authorization: `Bearer ${this.authUser.user.token}`,
        }
        this.$http
          .post(`${process.env.BASE_API_URL}/comments/?circle_id=${this.currentCircle.id}`, payload, { headers })
          .then(res => {
            this.reply = ""
            this.currentPage = 1
            this.comment.comments_count += 1
            this.comment_attach = []
            this.isImageUploading = false
            this.previewVisible = false
            this.previewImage = ""
            this.fileList = []
            // console.log("fileList ->", this.fileList)
            this.fetchReplies()
          })
          .catch(err => {
            this.setLoadingScreen(false)
          })
      } else {
        this.$notification.error({
          message: "Error",
          description: "Type something or add an image",
        })
      }
    },

    /**
     * Get reaction of a given type
     *
     * @param {Integer} type
     */
    getReaction(type) {
      let status = []
      status = this.comment.my_reaction.filter(reaction => {
        return reaction.reaction_type === type
      })
      return status
    },

    /**
     * Reaction to any post/comment. Based on the reaction, send required payload.
     *
     * @param {Object} post
     * @param {Object} event
     */
    react(entity, event, comment = false) {
      if (this.posting) {
        return
      }
      this.reactions.likes ? this.deleteReaction(2, "likes") : this.saveReaction(entity.id, 2, 2)
    },

    /**
     * Save reaction to post
     *
     * @param {Integer} postId
     * @param {Integer} reactionType
     * @param {Integer} reactionOnType
     */
    saveReaction(postId, reactionType, reactionOnType) {
      const MIRROR_REACTION_TYPES = { 1: "hugs", 2: "likes", 4: "favorites", 5: "flaged" }
      this.posting = true
      const user = JSON.parse(localStorage.getItem("user"))
      const currentCircle = JSON.parse(localStorage.getItem("currentCircle"))
      const payload = { reacted_on_type: reactionOnType, reacted_on_id: postId, user: user.user.id, reaction_type: reactionType }
      const headers = { Authorization: `Bearer ${user.user.token}` }

      this.$http
        .post(`${process.env.BASE_API_URL}/reactions/?circle_id=${currentCircle.id}`, payload, { headers })
        .then(res => {
          payload.reaction_type === 5 &&
            this.$http.put(`${process.env.BASE_API_URL}/comments/?id=${postId}`, { is_spam: true }, { headers }).then(response => {
              this.reactions.flag = true
              this.posting = false
            })
          this.reactions[MIRROR_REACTION_TYPES[reactionType]] = true
          this.comment.reaction[MIRROR_REACTION_TYPES[reactionType]] += 1
          const index = this.comment.my_reaction.findIndex(rs => rs.reaction_type === reactionType)
          if (index >= 0) {
            this.comment.my_reaction.splice(index, 1)
          }
          this.comment.my_reaction.push(res.data.data)
          this.posting = false
        })
        .catch(err => {
          this.posting = false
        })
    },

    /**
     * Delete reaction to post
     *
     * @param {Integer} reactionId
     */
    deleteReaction(reactionId, type) {
      this.posting = true
      const reactions = this.getReaction(reactionId)
      let ids = ""
      ids = reactions.map(reaction => {
        return reaction.id
      })
      const user = JSON.parse(localStorage.getItem("user"))
      const headers = { Authorization: `Bearer ${user.user.token}` }
      this.$http
        .delete(`${process.env.BASE_API_URL}/reactions/?ids=${ids.toString()}`, { headers })
        .then(res => {
          this.reactions[type] = false
          this.posting = false
          if (this.comment.reaction[type] > 0) {
            this.comment.reaction[type] -= 1
          }
        })
        .catch(err => {
          this.posting = false
        })
    },

    formatPostTime(value) {
      const d = new Date(value)
      const now = new Date()
      const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000))
      const minutes = Math.round(Math.abs(seconds / 60))
      const hours = Math.round(Math.abs(minutes / 60))
      const days = Math.round(Math.abs(hours / 24))
      const months = Math.round(Math.abs(days / 30.416))
      const years = Math.round(Math.abs(days / 365))
      if (Number.isNaN(seconds)) {
        return ""
      } else if (seconds <= 45) {
        return "a few seconds ago"
      } else if (seconds <= 90) {
        return "a minute ago"
      } else if (minutes <= 45) {
        return minutes + " minutes ago"
      } else if (minutes <= 90) {
        return "an hour ago"
      } else if (hours <= 22) {
        return hours + " hours ago"
      } else if (hours <= 36) {
        return "a day ago"
      } else if (days <= 25) {
        return days + " days ago"
      } else if (days <= 45) {
        return "a month ago"
      } else if (days <= 345) {
        return months + " months ago"
      } else if (days <= 545) {
        return "a year ago"
      } else {
        // (days > 545)
        return years + " years ago"
      }
    },

    formatPostTimeShort(value) {
      const d = new Date(value)
      const now = new Date()
      const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000))
      const minutes = Math.round(Math.abs(seconds / 60))
      const hours = Math.round(Math.abs(minutes / 60))
      const days = Math.round(Math.abs(hours / 24))
      const months = Math.round(Math.abs(days / 30.416))
      const years = Math.round(Math.abs(days / 365))
      if (Number.isNaN(seconds)) {
        return ""
      } else if (seconds <= 45) {
        return "a few seconds ago"
      } else if (seconds <= 90) {
        return "1m"
      } else if (minutes <= 45) {
        return minutes + "m"
      } else if (minutes <= 90) {
        return "1h"
      } else if (hours <= 22) {
        return hours + "h"
      } else if (hours <= 36) {
        return "1d"
      } else if (days <= 25) {
        return days + "d"
      } else if (days <= 45) {
        return "1 month"
      } else if (days <= 345) {
        return months + " months"
      } else if (days <= 545) {
        return "1 yr"
      } else {
        return years + " yrs"
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 426px) {
  .mobile-style {
    flex-wrap: wrap !important;
  }
  .mobile-write {
    margin-left: 0px !important;
  }
}
.commentor-name {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-transform: capitalize;
  color: #0f1734;
}
.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  .title {
    font-size: 16px;
    font-weight: bold;
  }

  .sub-title {
    font-size: 16px;
    font-weight: 500;
  }
  .flex-middle {
    display: flex;
    align-self: center;
  }
}
.send-icon {
  width: 0% !important ;
  height: 0% !important;
  position: absolute;
  right: 40px;
  // transform: scale(1.5);
  transform: scale(2);
  // top: 6px;
}
.poll-comment-image {
  width: 150px;
  height: 150px;
  margin: 10px;
  object-fit: contain;
  margin-left: 64px;
}
.card-item {
  font-weight: 500 !important;
  font-size: 16px !important;
  margin-left: 0 !important ;
}
.comment {
  // padding: 5px;
  margin-top: 16px;
  a {
    margin-left: 0px !important;
  }
}
@media screen and (max-width: 600px) {
  .mx-3 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .replyInput {
    font-size: 12px !important;
  }
}
.reply-cam-right {
  right: 100px;
  @media screen and (max-width: 600px) {
    right: 80px;
  }
}
.reply-arrow {
  margin-left: 8px !important;
  @media screen and (max-width: 600px) {
    margin-left: 0 !important;
    // margin-top: 6px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/QA/CommentReplyQANew.vue